import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=7bc823ec&scoped=true&"
import script from "./TopNavigation.vue?vue&type=script&lang=ts&"
export * from "./TopNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&id=7bc823ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc823ec",
  null
  
)

/* custom blocks */
import block0 from "./TopNavigation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports